import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createBlock(_component_q_select, {
    filled: "",
    modelValue: _ctx.company,
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => ((_ctx.company) = $event)),
      _ctx.selectCompany
    ],
    "use-input": "",
    "input-debounce": "0",
    label: _ctx.label,
    hint: _ctx.hint,
    options: _ctx.companies,
    onFilter: _ctx.filterCompany,
    dense: true,
    clearable: true,
    loading: _ctx.loading,
    readonly: _ctx.readonly
  }, {
    "no-option": _withCtx(() => [
      _createVNode(_component_q_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_section, { class: "text-grey" }, {
            default: _withCtx(() => [
              _createTextVNode(" Sin resultados ")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "label", "hint", "options", "onFilter", "onUpdate:modelValue", "loading", "readonly"]))
}